import React from 'react'
import { func, number, array, string } from 'prop-types'
import { translate } from 'react-i18next'

const StepComponent = ({ t, label, step, current }) => (
  <li className='step__item'>
    <p className={'step__number ' + (current === step ? 'step__number--active' : '')}>
      { step + 1 }
    </p>
    <p className='step__text'>{t(label)}</p>
  </li>
)

StepComponent.propTypes = {
  t: func,
  step: number,
  current: number,
  label: string
}

const StepperComponent = ({ children }) => (
  <ul className='step'>{ children }</ul>
)

StepperComponent.propTypes = {
  children: array
}

export const Step = translate()(StepComponent)
export const Stepper = translate()(StepperComponent)



// WEBPACK FOOTER //
// ./src/components/ui/states/Stepper.js